const initialstate = {
  adddata:[],
  data:[],
}

const OrgAddNeedsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_Add_data_success':
          return {... state, adddata:action.payload};
          case 'fetch_data_success':
          return {... state, data:action.payload};
                     default :
          return state;
  }
};
export default OrgAddNeedsReducers;